import { z } from "zod";

import { CLAIM_PREVIEW_TABS } from "@/features/tasks/components/claim-preview-panel";

/** Tabs of the « Suivi financier » page, in display order. */
export const financeTabs = ["receipts", "orders", "agencies"] as const;
export type FinanceTab = (typeof financeTabs)[number];

/**
 * The open tab lives in the URL so each one stays linkable; absent means the first.
 * `claim` / `claimTab` drive the claim side panel, as on /signatures.
 */
export const financeSearchSchema = z.object({
  tab: z.enum(financeTabs).optional().catch(undefined),
  claim: z.string().optional().catch(undefined),
  claimTab: z.enum(CLAIM_PREVIEW_TABS).optional().catch(undefined),
});

/** What a finance tab needs to open a claim in the side panel. */
export interface ClaimPreviewLinkProps {
  selectedClaimId: string | null;
  onOpenClaim: (claimId: string) => void;
}

/** Page sizes of the finance tables — the list endpoints cap `pageSize` at 100. */
export const FINANCE_PAGE_SIZES = [25, 50, 100] as const;

/** The claim-number search only keeps digits: the API expects a number. */
export function toClaimNumberFilter(value: string | undefined): string {
  return value?.replace(/\D/g, "") ?? "";
}
